// extracted by mini-css-extract-plugin
export default {"productnavbar":"ProductDetailNavbar_productnavbar__34P5o"};